import {Col, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Card, CardContent, Divider, Grid, ListSubheader, NativeSelect} from "@mui/material";
import {
  displayDay, displayEventTime,
  formatCurrency,
  formatDateMask,
  formatDateTimeTz, getPreferenceValue, maxMatrixPrice,
  urlSearchParams,
  validEvent
} from "../../common/Utils";
import RegisterEventModal from "../modal/RegisterEventModal";
import Loading from "../../common/Loading";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import {
  addtoWaitlist,
  getAgeRangeTypes, getCalendarInventoryEvents, getInventoryEvent,
  getInventoryEventTypes, getPortalInventoryEvents
} from "../../common/api/PortalCustomerApi";
import PreRegisterMemberOnlyEventModal from "../modal/PreRegisterMemberOnlyEventModal";
import {UserContext} from "../../../lib/UserProvider";
import {CartContext} from "../../../lib/CartProvider";
import FileSelector from "./calendarUI/FilterSelector";
import CalendarEvents from "./calendarUI/CalendarEvents";
import EventDetail from "../event/EventDetail";
import dayjs from "dayjs";
import {CalendarIcon, DatePicker} from "@mui/x-date-pickers";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {CompanyContext} from "../../../lib/CompanyProvider";
import Menu from "@mui/material/Menu";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from "@mui/material/MenuItem";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PortalCalendar from "../PortalCalendar";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {useConfirm} from "../../common/Confirmation";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function CustomerCalendarPane(props) {
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();

  const [calendarView, setCalendarView] = useState(props?.calendarView || false);
  const [partyView, setPartyView] = useState(props?.parties || false);

  const [calendarLoading, setCalendarLoading] = useState(true);
  const [noEvents, setNoEvents] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const initialDate = searchParams.get('eventDate');

  const [calendarJsDate, setCalendarJsDate] = useState(new Date());
  const [calendarDate, setCalendarDate] = useState();

  const [inventoryRender, setInventoryRender] = useState(1);
  const [events, setEvents] = useState(null);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);

  const [inventoryEvent, setInventoryEvent] = useState();
  const [showRegister, setShowRegister] = useState(false);
  const [showPreRegister, setShowPreRegister] = useState(false);
  const [viewCalendarEventDetail, setViewCalendarEventDetail] = useState(false);
  const [calendarEventDetail, setCalendarEventDetail] = useState();

  useEffect(() => {
    if (companyContext?.refreshContext) {
      setInventoryRender(setInventoryRender + 1);
    }
  }, [companyContext?.refreshContext]);

  useEffect(() => {
    if (!companyContext?.timeZone) {
      return;
    }
    if (userContext?.refreshIdentity) {
      setInventoryRender(setInventoryRender + 1);
      getInventoryEventsDayFn(calendarDate);
    }
  }, [companyContext?.timeZone, userContext?.refreshIdentity]);

  useEffect(() => {
    if (!events) {
      return;
    }
    setCalendarLoading(false);
  }, [events]);

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
  }

  const getAgeRangeTypesFn = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  useEffect(() => {
    getAgeRangeTypesFn();
  }, [companyContext?.company]);

  const showEvent = (_event) => {
    let show = (eventTypeFilter.length === 0 || eventTypeFilter.indexOf(_event.eventType.id) > -1);
    show = show && (ageRangeTypeFilter.length === 0 || ageRangeTypeFilter.indexOf(_event.ageRange.id) > -1);
    return show;
  };

  useEffect(() => {
    if (!calendarDate) {
      return;
    }
    if (!companyContext?.timeZone) {
      return;
    }
    if (!calendarView) {
      getInventoryEventsDayFn();
    }
  }, [companyContext?.timeZone, calendarDate]);

  useEffect(() => {
    if (initialDate) {
      setCalendarDate(dayjs(initialDate).toDate())
    } else {
      let dd = formatDateTimeTz(new Date(), 'YYYY-MM-DD', companyContext?.timeZone);
      let d = new Date();
      setCalendarDate(d);
    }
  }, [companyContext?.company])

  const initCalendar = (req) => {
    getInventoryEventsFn(req);
  }

  const getInventoryEventsDayFn = async () => {

    let startDate = new Date(calendarDate);

    const isoInstant = dayjs(calendarDate)
      .tz(companyContext?.timeZone)
      .toISOString();
    const isoEnd = dayjs(calendarDate)
      .tz(companyContext?.timeZone)
      .toISOString();
    let req = {
      start: isoInstant,
      end: isoEnd,
      specialEvents: partyView
    };

    setNoEvents(false);
    setCalendarLoading(true);

    let renderNum = inventoryRender + 1;
    let result = await getPortalInventoryEvents(req, inventoryRender);

    if ((result?.inventoryRender + 1) === renderNum) {
      setEvents(result.events);
      setNoEvents(result.events?.length === 0);
      setCalendarLoading(false);
    }
  }

  useEffect(() => {
    if (!companyContext?.timeZone) {
      return;
    }
    if (userContext?.reloadEvents) {
      let _u = {...userContext};
      _u.reloadEvents = false;
      setUserContext({..._u});
      getInventoryEventsDayFn();
    }
  }, [companyContext?.timeZone, userContext?.reloadEvents]);

  const getInventoryEventsFn = async (req) => {

    setNoEvents(false);
    setCalendarLoading(true);

    let renderNum = inventoryRender + 1;
    let result = await (isMobile ? getPortalInventoryEvents(req, inventoryRender) : getCalendarInventoryEvents(req, inventoryRender));

    if ((result?.inventoryRender + 1) === renderNum) {
      setEvents(result.events);
      setCalendarEvents(displayEvents(result.events));
      setNoEvents(result.events?.length === 0);
      setCalendarLoading(false);
    }
  }

  const showSessionChildRegistration = (event) => {
    if (event.parentSessionEventDate) {
      let tempEvent = {...event};
      tempEvent.allDay = event.allDay;
      tempEvent.eventDate = event.parentSessionEventDate;
      return validEvent(tempEvent);
    }
    return false;
  }

  const hideSessionRegistration = (event) => {
    return event.childSessionEvent;
  }

  const [eventTypeFilter, setEventTypeFilter] = useState([]);
  const [ageRangeTypeFilter, setAgeRangeTypeFilter] = useState([]);

  useEffect(() => {
    let _params = searchParams.get('parties');
    let _eventTypes = [];
    if (_params || partyView) {
      getInventoryEventTypes().then((r) => {
        let _types = [];
        for (let k in r) {
          if (r[k].specialEvent) {
            _types.push(r[k].id)
            _eventTypes.push(r[k]);
          }
        }
        setInventoryEventTypes(_eventTypes)
      })
    } else {
      getInventoryEventTypes().then((r) => {
        let _types = [];
        for (let k in r) {
          if (!r[k].specialEvent) {
            _types.push(r[k].id)
            _eventTypes.push(r[k]);
          }
        }
        setInventoryEventTypes(_eventTypes)
      })
    }
  }, [companyContext?.company])

  useEffect(() => {
    let _params = searchParams.get('eventType');
    if (_params) {
      let _types = _params.split(',');
      let _list = [];
      for (let j in _types) {
        _list.push(parseInt(_types[j], 10));
      }
      setEventTypeFilter(_list);
    }
  }, [companyContext?.company])

  useEffect(() => {
    let _params = searchParams.get('ageType');
    if (_params) {
      let _types = _params.split(',');
      let _list = [];
      for (let j in _types) {
        _list.push(parseInt(_types[j], 10));
      }
      setAgeRangeTypeFilter(_list);
    }
  }, [companyContext?.company])


  useEffect(() => {
    if (ageRangeTypeFilter && ageRangeTypeFilter?.length > 0) {
      searchParams.set('ageType', ageRangeTypeFilter.join(','))
    } else {
      searchParams.delete('ageType');
    }
    setSearchParams(searchParams);
  }, [ageRangeTypeFilter])

  useEffect(() => {
    if (eventTypeFilter && eventTypeFilter?.length > 0) {
      searchParams.set('eventType', eventTypeFilter.join(','))
    } else {
      searchParams.delete('eventType');
    }
    setSearchParams(searchParams);
  }, [eventTypeFilter])

  const preRegisterEvent = (event) => {
    let _e = {...event};
    _e.actionDate = new Date();
    setInventoryEvent(_e);
    if (event?.bookedFull && !event?.eventType?.disableWaitlist) {
      addToWaitlistFn(_e);
      return;
    }

    if (event?.eventType?.memberOnly) {
      setShowPreRegister(true);
    } else {
      setShowRegister(true);
    }
  }

  const registerMembershipEvent = (event, memberAccount) => {
    let _e = {...event};
    _e.memberAccount = {...memberAccount};
    _e.actionDate = new Date();
    setInventoryEvent(_e);
    setShowRegister(true);
  }

  const handleCloseRegisterEventModal = () => {
    setShowRegister(false);
    setShowPreRegister(false);
  }

  const handleRefreshCart = () => {
    handleCloseRegisterEventModal();
    setCartContext({...cartContext, reloadCart: true, viewCart: true});
  }

  const addToWaitlistFn = async (e) => {
    if (!userContext?.sessionUser?.guid) {
      setUserContext({...userContext, showLogin: true});
      return;
    }
    addtoWaitlist(e).then(resp => {
      setCartContext({...cartContext, reloadCart: true});
      let _context = {...context};
      _context.toast = {
        message: 'Added to Event Wait List!',
      }
      setContext({..._context});
      e.waitlisted = true;
      return e;
    });
  };


  const updateEventDates = (date) => {
    setCalendarJsDate(new Date(date));
    setCalendarDate(dayjs(date)
      .tz(companyContext?.timeZone));
    searchParams.set('eventDate', formatDateMask(date, 'YYYY-MM-DD'));
    setSearchParams(searchParams);
  };

  const displayEvents = (events) => {
    let _events = [];
    for (let i = 0; i < events?.length; i++) {
      let event = events[i];
      let endDate = new Date(event.eventDate);
      endDate.setTime(endDate.getTime() + (event.eventDuration * 1000 * 60));

      let _e = {
        guid: event.guid,
        eventType: event?.eventType,
        title: event.name,
        allDay: event?.allDay,
        timeBlock: event.timeBlockParent,
        start: formatDateTimeTz(event.eventDate, 'YYYY-MM-DD HH:mm:ss', companyContext?.timeZone),
        end: formatDateTimeTz(endDate, 'YYYY-MM-DD', companyContext?.timeZone),
        displayTime: formatDateTimeTz(event.eventDate, 'h:mm a', companyContext?.timeZone),
        timeBlockEvents: event.timeBlockEvents,
        bookedFull: event.bookedFull,
        validEvent: validEvent(event),
        ageRange: event?.ageRange,
        specialEvent: event?.eventType?.specialEvent
      }
      _events.push(_e);
    }
    return _events;
  }

  function renderEventContent(eventInfo) {
    let bookedFull = eventInfo?.event?.extendedProps?.bookedFull;
    let _validEvent = eventInfo.event?.extendedProps?.validEvent;
    let timeBlockEvent = eventInfo.event?.extendedProps?.timeBlock;

    if (timeBlockEvent && !bookedFull) {
      let hasEvents = true;
      let tbBookedEvents = 0;
      for (let j in eventInfo.event?.extendedProps?.timeBlockEvents) {
        if (eventInfo.event?.extendedProps?.timeBlockEvents[j].bookedFull) {
          tbBookedEvents += 1;
        }
      }
      if (eventInfo.event?.extendedProps?.timeBlockEvents?.length === tbBookedEvents) {
        bookedFull = true;
      }
    }

    let bgColor = 'inherit';
    let fontColor = 'inherit';
    if (eventInfo?.event?.extendedProps?.eventType?.backgroundColor) {
      bgColor = eventInfo?.event?.extendedProps?.eventType?.backgroundColor;
    }
    if (eventInfo?.event?.extendedProps?.eventType?.fontColor) {
      fontColor = eventInfo?.event?.extendedProps?.eventType?.fontColor
    }

    return (
      <Card className=" w-100 "
            style={{
              whiteSpace: 'pre-wrap',
              backgroundColor: bgColor,
              padding: 0,
              margin: '2px',
              borderRadius: '8px',
              opacity: _validEvent && !bookedFull ? '1' : '0.25'
            }}>
        <CardContent style={{
          margin: '0',
          padding: '4px 8px 22px 8px'
        }}>
          <MDTypography variant="p" style={{
            color: fontColor
          }} fontWeight="bold">
            {eventInfo.event?.title}
          </MDTypography>
          <br/>
          <MDTypography variant="p" style={{
            color: fontColor
          }} fontWeight="regular">
            {!timeBlockEvent && <>
              {eventInfo.event?.allDay && 'All Day'}
              {!eventInfo.event?.allDay && eventInfo.event?.extendedProps?.displayTime}
              {bookedFull ? <><br/>Booked Full</> : <></>}
            </>}
            {timeBlockEvent && <>
              Multiple Times
            </>}
          </MDTypography>
        </CardContent>
      </Card>
    )
  }

  const handleCloseCalendarEventDetail = () => {
    setViewCalendarEventDetail(false)
    setCalendarEventDetail(null);
  }

  const toggleCalendarEventDetail = () => {
    setViewCalendarEventDetail(!viewCalendarEventDetail);
  }

  const handleDatesSet = (info) => {
    let startDate = new Date(info.start);
    startDate.setHours(0, 0, 0, 0);
    let endDate = new Date(info.end);

    let req = {
      start: startDate,
      end: endDate,
      specialEvents: partyView
    }
    getInventoryEventsFn(req);
  }

  const viewParentSessionEvent = (guid) => {
    setViewCalendarEventDetail(true);
    getInventoryEvent(guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCalendarEventDetail(result);
      }
    });
  }

  const agendaViewEvent = (evt) => {
    setViewCalendarEventDetail(true);
    getInventoryEvent(evt.guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCalendarEventDetail(result);
      }
    });
  }


  const calendarViewEvent = (evt) => {
    setViewCalendarEventDetail(true);
    getInventoryEvent(evt.event?.extendedProps?.guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCalendarEventDetail(result);
      }
    });
  }

  const NoteItemActions = ({item}) => {

    let singleOption = item?.memberAccountTypes.length === 1;

    return (
      singleOption ? <>
          <MDButton variant="gradient"
                    size={'small'}
                    color="info"
                    onClick={(e) => {
                      handleCloseCalendarEventDetail();
                      registerMembershipEvent(item, item?.memberAccountTypes[0]);
                    }}>Register With {item?.memberAccountTypes[0].name}</MDButton>
        </> :

        <><PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
          {(popupState) => (
            <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton size={'small'}
                     color="primary"
           >Register with Membership <KeyboardArrowDownIcon/></MDButton>
          </span>
              <Menu {...bindMenu(popupState)}>
                <ListSubheader>
                  Choose Option
                </ListSubheader>
                {item?.memberAccountTypes.map((_row, index) => {
                  return (
                    <MenuItem
                      key={index}
                      onClick={(e) => {
                        popupState.close();
                        registerMembershipEvent(item, _row);
                        handleCloseCalendarEventDetail();
                      }} title={'Register with ' + _row.name}>
                      {_row.name}
                    </MenuItem>
                  )
                })
                }
              </Menu>
            </>
          )}
        </PopupState>
        </>
    );
  }

  const selectTimeBlockEvent = (guid) => {
    let eventFound = false;
    for (const k in events) {
      if (events[k].timeBlockEvents?.length > 0) {
        for (const kk in events[k].timeBlockEvents) {
          if (events[k].timeBlockEvents[kk].guid === guid) {
            let _e = {...events[k].timeBlockEvents[kk]};
            _e.timeBlockParent = false;
            eventFound = true;
            preRegisterEvent(_e);
          }
        }
      }
    }
    return eventFound;
  }

  const hideTimeBlockRegistration = (event) => {
    return event?.timeBlockEvents?.length > 0;
  }

  const {confirm, ConfirmationDialog} = useConfirm();
  const [confirmation, setConfirmation] = useState(null);


  const eventDetail = (event, modalView) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={9}>
          <EventDetail
            showDesc={true}
            embedded={false}
            event={event}
            packages={false}
            callback={() => {
            }}
            handleCloseCalendarEventDetail={handleCloseCalendarEventDetail}>
            {!validEvent(event) && hideSessionRegistration(event) && !showSessionChildRegistration(event)
              && <div style={{
                marginTop: '5px'
              }}>
            <span>
              <MDTypography variant="p" fontWeight="bold" className="mb-2"
              >This Session series has already started.
              </MDTypography><br/>
              <MDButton variant="gradient"
                        size={'small'}
                        className="mt-2"
                        color="info"
                        disabled="true"
              >View Session Details</MDButton></span>
              </div>}
          </EventDetail>
        </Grid>
        <Grid item xs={12} sm={3}>
          <div>

            {!event?.eventType?.memberOnly && validEvent(event) && !event?.eventType?.eventTypeInformational &&
              <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>
                <p>
                  {!event?.eventMatrix && parseInt(event?.price, 10) > 0 &&
                    <b>{(event?.packageRequired ? 'Starting ' : '') + 'Price: ' + formatCurrency(event.price)}</b>
                  }
                  {event?.eventMatrix &&
                    <b>Price: {formatCurrency(maxMatrixPrice(event))}</b>
                  }
                </p>
              </MDBox>
            }

            <div style={{
              display: event?.eventType?.eventTypeInformational ? 'none' : 'block'
            }}>
              {validEvent(event) && <div>
                <MDBox my={2}>
                  {hideSessionRegistration(event) && showSessionChildRegistration(event) &&
                    <>
                      <MDTypography variant="p" className="mb-2"
                      >This event is in a Session series.
                      </MDTypography><br/>
                      <MDButton variant="gradient"
                                className="mt-2"
                                color="info"
                                onClick={(e) => {
                                  viewParentSessionEvent(event.parentEventGuid);
                                }}>View Session Details</MDButton></>
                  }
                  {!hideSessionRegistration(event) && <>
                    {!hideTimeBlockRegistration(event) && event.bookedFull &&
                      <>
                        <Grid container>
                          <Grid item xs={12} alignContent={'flex-end'}>
                            <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>
                              <MDButton variant="gradient"
                                        disabled={event.waitlisted || (event.bookedFull && event?.eventType?.disableWaitlist)}
                                        color={event?.eventType?.disableWaitlist ? 'secondary' : 'info'}
                                        onClick={(e) => {
                                          addToWaitlistFn(event);
                                          event.joiningWaitList = true;
                                        }}>

                                {event?.eventType?.disableWaitlist && <>
                                  Booked Full
                                </>}
                                {!event?.eventType?.disableWaitlist && <>
                                  {!event.waitlisted && <>{event.joiningWaitList ? 'Joining' : 'Join'} Wait List</>}
                                  {event.waitlisted && <>On Waiting List</>}
                                </>}
                              </MDButton>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </>


                    }
                  </>}
                  {!hideSessionRegistration(event) && <>
                    {(event.timeBlockParentGuid?.length > 0 || !event.bookedFull) && <>

                      <Grid container>
                        <Grid item xs={12} alignContent={'flex-end'}>
                          <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>

                            {validEvent(event) && event.timeBlockParentGuid?.length > 0 && event.timeBlockParentGuid?.length > 0
                              && event.timeBlockEvents?.filter((event) => validEvent(event, 'time block picker'))?.length === 0 && <>
                                <MDButton size={'small'}
                                          disabled={true}
                                          color="secondary">Registration closed</MDButton>
                              </>
                            }
                            {validEvent(event, 'Customer calendar pane') && <>
                              {event.timeBlockParentGuid?.length > 0 && <table>
                                <tbody>
                                {!modalView && event.timeBlockEvents?.length > 5 &&
                                  <tr>
                                    <td>
                                      <NativeSelect onChange={(e) => {
                                        if (selectTimeBlockEvent(e.target.value)) {
                                          handleCloseCalendarEventDetail();
                                        }
                                      }}
                                                    variant="outlined"
                                                    name={'familyMemberType'} className={'form-control'}>
                                        <option>Choose Time</option>
                                        {event.timeBlockEvents?.sort((e1, e2) => {
                                          return new Date(e1.eventDate).getTime() - new Date(e2.eventDate).getTime()
                                        })?.filter((event) => validEvent(event, 'time block picker'))?.map((tbe, idx) => {
                                          return (
                                            <option value={tbe.guid}
                                                    disabled={tbe.bookedFull}
                                                    key={idx}>
                                              {displayEventTime(tbe, companyContext?.timeZone, 'hh:mm a')}
                                              {tbe.bookedFull ? ' (Booked Full)' : ''}
                                            </option>
                                          )
                                        })
                                        }
                                      </NativeSelect>
                                    </td>
                                  </tr>
                                }
                                {(modalView || event.timeBlockEvents?.length <= 5) &&
                                  event.timeBlockEvents?.sort((e1, e2) => {
                                    return new Date(e1.eventDate).getTime() - new Date(e2.eventDate).getTime()
                                  })?.filter((event) => validEvent(event, 'time block picker'))?.map((tbe, idx) => {
                                    return (
                                      <tr key={idx} style={{
                                        display: 'block !important',
                                        width: '100%',
                                        clear: 'both'
                                      }} className={'d-block m-1'}>
                                        <td>
                                          {companyContext?.timeZone &&
                                            <MDButton key={idx} size={'small'}
                                                      disabled={tbe.bookedFull && tbe.eventType?.disableWaitlist}
                                                      color="primary"
                                                      variant={"outlined"}
                                                      onClick={(e) => {
                                                        handleCloseCalendarEventDetail();
                                                        let _tbe = {...tbe};
                                                        _tbe.timeBlockParent = false;
                                                        preRegisterEvent(_tbe);
                                                      }}>
                                              {displayEventTime(tbe, companyContext?.timeZone, 'hh:mm a')}
                                              {tbe.bookedFull && <><br/>{
                                                tbe.eventType?.disableWaitlist ? '(Booked Full)' : 'Join Wait List'
                                              }</>}
                                            </MDButton>
                                          }
                                        </td>
                                      </tr>
                                    )
                                  })
                                }
                                </tbody>
                              </table>}
                              {!event.timeBlockParentGuid?.length > 0 && <>
                                <MDButton size={'small'}
                                          color="secondary"
                                          onClick={async (e) => {
                                            if (event?.reservationStatus?.id > -1) {
                                              let _confirmation = {
                                                title: 'Registration',
                                                message: 'You are already registered for this event. Are you sure you wish to continue?'
                                              };
                                              setConfirmation(_confirmation);
                                              toggleCalendarEventDetail();

                                              const ok = await confirm(_confirmation);
                                              if (!ok) {
                                                setViewCalendarEventDetail(true);
                                                setConfirmation(null);
                                                return;
                                              }
                                            }
                                            handleCloseCalendarEventDetail();
                                            preRegisterEvent(event);
                                          }}>Register</MDButton>
                              </>}
                            </>}
                            {!validEvent(event, 'Customer calendar pane') && <>
                              <MDButton size={'small'}
                                        disabled={true}
                                        color="secondary">Registration closed</MDButton>
                            </>
                            }
                          </MDBox>
                        </Grid>
                      </Grid>


                    </>
                    }
                  </>
                  }
                </MDBox>
              </div>
              }

              {!validEvent(event, 'Customer calendar pane') && <>
                <div>
                  <Grid container>
                    <Grid item xs={12} alignContent={'flex-end'}>
                      <MDBox display="flex" justifyContent={{xs: 'flex-start', sm: 'flex-end'}}>
                        <MDBox my={2}>
                          <MDButton size={'small'}
                                    disabled={true}
                                    color="secondary">Registration closed</MDButton>
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>
                </div>
              </>
              }

            </div>
          </div>
        </Grid>
      </Grid>
    )
  }

  return (
    <div>
      <div>
        <MDBox>

          <h1>

            {partyView && <>
              {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_parties', 'Parties')}
            </>
            }
            {!partyView && <>
              {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_events', 'Calendar')}
            </>}

          </h1>

          <div style={{display: 'block', clear: 'both', marginTop: '12px'}}>

            <span style={{
              marginRight: '8px'
            }}>
              <FileSelector
                types={inventoryEventTypes}
                typeFilter={eventTypeFilter}
                filterLabel={'Event Types'}
                setFilter={(filters) => {
                  setEventTypeFilter(filters)
                }}
              />
            </span>

            <FileSelector
              types={ageRangeTypes}
              typeFilter={ageRangeTypeFilter}
              filterLabel={'Ages'}
              setFilter={(filters) => {
                setAgeRangeTypeFilter(filters);
              }}
            />
          </div>

          {calendarLoading && calendarView && !isMobile && <>
            <Col sm={12}>
              <Loading large={true}/></Col></>}

          {!calendarView && <Grid container spacing={1} sx={{
            paddingTop: '8px'
          }}>
            <Grid item>
              <DatePicker
                sx={{
                  borderRadius: '0',
                  marginBottom: '8px',
                  width: {xs: '100%', sm: '300px'},
                  '& .MuiInputBase-root': {
                    borderRadius: '0',
                  },
                }}
                slotProps={{
                  actionBar: {
                    actions: ['today', 'accept'],
                  },
                }}
                value={dayjs(calendarDate)
                  .tz(companyContext?.timeZone)}
                onChange={(e) => {
                  updateEventDates(new Date(e.$d));
                }}
              />
            </Grid>
            <Grid item justifyContent={'flex-end'}>
            <span className="d-inline-block">
                        <MDButton
                          sx={{
                            borderRadius: "0"
                          }}
                          color="primary"
                          onClick={() => {
                            if (calendarView) {
                              if (partyView) {
                                navigate('/cx/parties' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                              } else {
                                navigate('/cx/events' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                              }
                            } else {
                              if (partyView) {
                                navigate('/cx/parties-calendar' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                              } else {
                                navigate('/cx/calendar' + (urlSearchParams('eventType', searchParams.get('eventType'), '?')));
                              }
                            }
                          }}>
                        <CalendarIcon/>&nbsp;
                          {!calendarView ? 'Calendar View' : 'List View'}
                      </MDButton>
                    </span>
            </Grid>
          </Grid>
          }
          {calendarView && isMobile && <MDBox>

            {calendarLoading && <Col sm={12}><Loading/></Col>}

            <PortalCalendar initCalendar={initCalendar}
                            partyView={partyView}
                            renderEventContent={renderEventContent}
                            handleDatesSet={handleDatesSet}
                            events={events}
                            eventClick={agendaViewEvent}
                            eventTypesFilter={eventTypeFilter}
                            ageTypeFilter={ageRangeTypeFilter}/>
          </MDBox>}

          {calendarView && !isMobile && <MDBox p={1}>
            <CalendarEvents
              parties={props?.parties || false}
              initCalendar={initCalendar}
              renderEventContent={renderEventContent}
              handleDatesSet={handleDatesSet}
              events={calendarEvents}
              eventClick={calendarViewEvent}
              eventTypesFilter={eventTypeFilter}
              ageTypeFilter={ageRangeTypeFilter}
            />
          </MDBox>}

          {!calendarView && <>
            <MDBox m={1}>
              <Col xs={12}>
                <Row>

                  {!calendarLoading && noEvents && <Col sm={12}>
                    <MDTypography variant="h5" fontWeight="light" color="secondary">
                      <center>No Events found for {displayDay(calendarJsDate, 'dddd, MMMM Do, YYYY')}</center>
                      <Divider/>
                    </MDTypography>
                  </Col>}

                  {calendarLoading && <Col sm={12}><Loading/></Col>}


                  {events?.length > 0 && (events.filter(item => showEvent(item))).length === 0 &&
                    <MDTypography variant="h5" fontWeight="light" color="secondary">
                      <center>No Events found for selected filters</center>
                      <Divider/>
                    </MDTypography>
                  }
                  {!calendarLoading && events && events?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                    .filter(item => showEvent(item))
                    .map((event, index) => {
                      return (
                        <div key={index}
                             style={{
                               opacity: validEvent(event) ? '1' : '0.6'
                             }} className={'xs-psb-bordered xs-psb-carded'}>
                          {eventDetail(event)}
                          <Divider/>
                        </div>
                      )
                    })
                  }
                </Row>
              </Col>
            </MDBox>
          </>
          }
        </MDBox>
      </div>

      {viewCalendarEventDetail && <>
        <Modal onHide={handleCloseCalendarEventDetail} size={'lg'} fullscreen={true}
               dialogClassName={'psb-page-overlay psb-overlay-medium'} show={viewCalendarEventDetail}>
          {!calendarEventDetail && <Modal.Body>
            <Loading/>
          </Modal.Body>}
          {calendarEventDetail &&
            <>
              <Modal.Header closeButton>
                <Modal.Title>{calendarEventDetail.name} Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {eventDetail(calendarEventDetail, true)}
              </Modal.Body>
            </>
          }
        </Modal>
      </>}

      {
        inventoryEvent && <RegisterEventModal
          handleClose={handleCloseRegisterEventModal}
          show={showRegister}
          event={inventoryEvent}
          refreshCart={handleRefreshCart}
          callback={(cb) => {
          }}
        />
      }

      {
        inventoryEvent && <PreRegisterMemberOnlyEventModal
          handleClose={handleCloseRegisterEventModal}
          show={showPreRegister}
          event={inventoryEvent}
          refreshCart={handleRefreshCart}
          callback={(cb) => {
          }}
        />
      }

      {confirmation && <ConfirmationDialog/>}

    </div>
  )
}